import { Link } from 'react-router-dom';

/**
 * Placeholder Privacy Policy copy -- pending legal sign-off. Exists so the Footer's
 * "Privacy Policy" link (and the Register page's consent checkbox) resolve to a real page
 * instead of the 404 catch-all. Replace the body copy once legal provides final text.
 */
export default function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <Link to="/" className="text-sm text-primary-500 hover:text-primary-600">&larr; Back to BookBed</Link>
      <h1 className="mt-6 text-3xl font-bold text-gray-900">Privacy Policy</h1>
      <p className="mt-2 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-800">
        Placeholder — pending legal review. This page does not yet contain final, legally-reviewed terms.
      </p>
      <div className="mt-8 space-y-6 text-sm leading-6 text-gray-700">
        <section>
          <h2 className="text-lg font-semibold text-gray-900">1. Information we collect</h2>
          <p className="mt-2">We collect the information you provide when creating an account (name, email, phone) and information generated by using BookBed (bookings, messages, reviews).</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-gray-900">2. How we use your information</h2>
          <p className="mt-2">We use your information to operate BookBed, process bookings, communicate with you, and improve our services.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-gray-900">3. Sharing</h2>
          <p className="mt-2">We share booking details with the relevant host or guest as needed to fulfil a reservation, and do not sell your personal information to third parties.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-gray-900">4. Your choices</h2>
          <p className="mt-2">You can access, update, or request deletion of your account information at any time from your account settings.</p>
        </section>
      </div>
    </div>
  );
}
